<template>
    <div class="loading-box">
        <div class="loading-list">
            <div class="loading-item display-flex display-flex-sb mb-2163px">
                <div class="display-flex-align-center">
                    <div class="circle circle-small-text animation mr-05rem"></div>
                    <div class="pill pill-small-text animation"></div>
                </div>
                <div class="display-flex-align-center gap-4px">
                    <div class="pill-default-size" v-for="(i,index) in [18,9,7,4,6,8]" :key="index">
                        <div :class="`pill pill-small-text animation pill-${i}`"></div>
                    </div>
                </div>
            </div>

            <div class="loading-item display-flex display-flex-sb mb-5px standing-item" 
                :class="{'live-sideline' : index < 5}"
                v-for="(i,index) in 20" :key="index">
                <div class="display-flex-align-center">
                    <div class="pill pill-small-text animation pill-6 mr-1550px"></div>
                    <div class="rect rect-sugar animation mr-0922px"></div>
                    <div class="pill pill-small-text animation"></div>

                </div>
                <div class="display-flex-align-center gap-4px">
                    <div class="pill-default-size" v-for="(i,index) in [18,9,7,4,6,8]" :key="index">
                        <div :class="`pill pill-small-text animation pill-${i}`"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading2'
    }
</script>


<style scoped src="../../assets/css/loading/index.css"></style>